<template>
  <div>
    <div v-if="user">
      <h1>User's status: {{ user.status }}</h1>
    </div>
    <div id="count-to-five">
      <button v-on:click="countToFive">Delay 5 seconds</button>
      <p class="h3 my-2">Counter: {{ counter }} seconds</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "test",
  data: function() {
    return {
      counter: 0
    };
  },
  props: ["user"],
  methods: {
    delayInSecond: function(sec) {
      return new Promise(resolve => setTimeout(resolve, sec * 1000));
    },
    countToFive: async function() {
      console.log("zero seconds");
      this.counter = 0;
      await this.delayInSecond(1);
      console.log("one seconds");
      this.counter += 1;
      await this.delayInSecond(1);
      console.log("two seconds");
      this.counter += 1;
      await this.delayInSecond(1);
      console.log("three seconds");
      this.counter += 1;
      await this.delayInSecond(1);
      console.log("four seconds");
      this.counter += 1;
      await this.delayInSecond(1);
      console.log("five seconds");
      this.counter += 1;
    }
  }
};
</script>
